module.exports = __webpack_public_path__ + "static/fonts/Fact-Italic.ec0985b.ttf";